
import { Image } from "utils"
import SETTINGS from "settings"

const star = `
float Pi = 3.14159265359;

uniform float iTime;

//ignoring (or not even declaring) this variable crashes PIXI:
varying vec2 vTextureCoord;
uniform sampler2D uSampler;

vec4 star( vec2 pos, vec2 center, float t )
{
    //rotate:
    float speed = t / 5.0;
    float st = sin( speed );
    float ct = cos( speed );
    pos -= center;
    pos *= mat2(
        ct, - st,
        st, ct
    );
    pos += center;
    
    vec2 dist = abs( center - pos );
    float longDist = length( dist );
    
    /*//distinguishing:
    float d = 101.0 - 100.0 * ( longDist * longDist * longDist );
    if ( d < 0.0 ) return vec4( 0.0 );*/
    
    //beam once per <> cycles:
    float hz = t * 20.0;
    float beam =
        mod( floor( hz / Pi ), 24.0 ) == 0.0
        ?
        sin( mod( hz, Pi ) )
        :
    	0.0
    ;
    float magnitude = 1.5 + 3.0 * beam;
    
    // add pointiness
    dist += longDist / 5.0;
    
    vec2 uv = magnitude / dist;
    
    float power = ( uv.x + uv.y ) / 3200.0;
    
    vec3 star_color = vec3( 1.2 );
    
    return vec4( star_color * power, 1.0 );
}

void main()
{
    //vec2 pos = fragCoord.xy / iResolution.xy;
    vec2 pos = vTextureCoord;
    
    vec4 bcg = texture2D( uSampler, vTextureCoord );
    
    float t = iTime;
    
    bcg += star( pos, vec2( 0.07, 0.08 ), t * 1.02 + 100.0 );
    bcg += star( pos, vec2( 0.47, 0.07 ), t * 1.05 + 130.0 );
    bcg += star( pos, vec2( 0.04, 0.48 ), t + 10.0 );
    bcg += star( pos, vec2( 0.3, 0.18 ), t * 1.1 + 20.0 );
    bcg += star( pos, vec2( 0.1, 0.22 ), t * 0.92 + 5.0 );
    bcg += star( pos, vec2( 0.4, 0.3 ), t * 1.2 + 7.0 );
    bcg += star( pos, vec2( 0.6, 0.2 ), t * 1.07 + 12.0 );
    bcg += star( pos, vec2( 0.32, 0.52 ), t * 1.25 + 50.0 );
    bcg += star( pos, vec2( 0.55, 0.47 ), t * 1.15 + 55.0 );
    bcg += star( pos, vec2( 0.15, 0.53 ), t * 1.25 + 50.0 );
    bcg += star( pos, vec2( 0.57, 0.31 ), t * 1.15 + 55.0 );
    bcg += star( pos, vec2( 0.29, 0.6 ), t * 1.03 + 110.0 );

    //adding light is much better than mix'ing because mixing darkens colors:
    //gl_FragColor = vec4( mix( bcg, star_color, /*0.5*/power ), 1.0 );
    
    gl_FragColor = bcg;
}
`

export default function( space, container )
{
    //any image just needed to make PIXI work - couldn't run shader without any textures:
    const cloth = Image( "res/common/progressive_jackpot/diamond_background.jpg" )
    cloth.width = SETTINGS.canvas.width
    cloth.height = SETTINGS.canvas.height
    
    const shader = new PIXI.Filter(
        null,
        star
    )
    shader.uniforms.iTime = 0.0;
    space.s( "ticker" ).on( seconds => {
        shader.uniforms.iTime += seconds
    } )
    
    cloth.filters = [ shader ]
    container.addChild( cloth )
}





// WEBPACK FOOTER //
// ./src/library/progressive_jackpot/star.es6